import LoginEpic from './LoginEpic'
import ApplicationsEpic from './ApplicationsEpic'
import ResetPasswordEpic from './ResetPasswordEpic'
import RegistrationEpic from './RegistrationEpic'
import CurrentUserInfoEpic from './CurrentUserInfoEpic'
import SelectedUserInfoEpic from './SelectedUserInfoEpic'
import UpdateUserInfoEpic from './UpdateUserInfoEpic'
import UpdateCurrentUserInfoEpic from './UpdateCurrentUserInfoEpic'
import EnterpriseAccountUserReportBatchEpic from './EnterpriseAccountUserReportBatchEpic'

import UpdateLicenseEpic from './UpdateLicenseEpic'
import InvitationResultsEpic from './InvitationResultsEpic'
import ShowLicenseEpic from './ShowLicenseEpic'
import CountriesEpic from './CountriesEpic'
import EnterpriseAccountShowEpic from './EnterpriseAccountShowEpic'
import EnterpriseAccountListEpic from './EnterpriseAccountListEpic'
import InvitationsEpic from './InvitationsEpic'
import EnterpriseAccountAddUserEpic from './EnterpriseAccountAddUserEpic'
import EnterpriseAccountCreateEpic from './EnterpriseAccountCreateEpic'
import EnterpriseAccountUpdateEpic from './EnterpriseAccountUpdateEpic'

import CreateScheduleForUserEpic from './cogoland/CreateScheduleForUserEpic'
import UsersWithStatusEpic from './cogoland/UsersWithStatusEpic'
import GetScheduleByUserEpic from './cogoland/GetScheduleByUserEpic'
import RescheduleSessionEpic from './cogoland/RescheduleSessionEpic'



export default [
  LoginEpic,
  EnterpriseAccountCreateEpic,
  EnterpriseAccountUpdateEpic,
  ApplicationsEpic,
  ResetPasswordEpic,
  RegistrationEpic,
  SelectedUserInfoEpic,
  CurrentUserInfoEpic,
  UpdateCurrentUserInfoEpic,
  CountriesEpic,
  EnterpriseAccountShowEpic,
  EnterpriseAccountListEpic,
  ShowLicenseEpic,
  InvitationsEpic,
  SelectedUserInfoEpic,
  UpdateLicenseEpic,
  InvitationResultsEpic,
  EnterpriseAccountAddUserEpic,
  UpdateUserInfoEpic,
  UsersWithStatusEpic,
  GetScheduleByUserEpic,
  CreateScheduleForUserEpic,
  RescheduleSessionEpic,
  EnterpriseAccountUserReportBatchEpic
]



// WEBPACK FOOTER //
// ./src/epics/index.js